module.exports = __webpack_public_path__ + "img/features2.56d763e1.png";